<div class="flex-1 overflow-y-auto p-2">
  @if (isLoading()) {
  <div class="h-full flex items-center justify-center flex-col gap-4 min-h-[300px]">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="animate-spin text-gray-400">
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
    <!-- <p class="text-gray-500 font-medium animate-pulse">Loading products...</p> -->
  </div>
  } @else if (products().length === 0) {
  <div class="h-64 flex flex-col items-center justify-center text-gray-400">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mb-4 opacity-20">
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
    <p class="text-lg font-medium">{{'SYSMESER0004' | translate}}</p>
  </div>
  } @else {
  <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-2">
    @for (product of products(); track product.servicE_CD) {
    <app-product-card [product]="product" (addToCart)="onAddToCart($event)" (viewDetails)="onViewDetails($event)" [l_ClassName] = "l_ClassName()" [s_ClassName] = "s_ClassName()">
    </app-product-card>
    }
  </div>
  }
</div>